import { useEffect, useState } from 'react';
import { trackHelpDeskInterceptEvent } from '../events/trackHelpDeskInterceptEvent';
import { HelpDeskInterceptAlert } from './HelpDeskInterceptAlert';
import { useHasSeenInboxIntercept } from '../hooks/useHasSeenInboxIntercept';
import { useSetSeenInboxInterceptSetting } from '../hooks/useSetSeenInboxInterceptSetting';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaybeHelpDeskInboxIntercept = () => {
  const [isOpen, setIsOpen] = useState(false);
  const hasSeenIntercept = useHasSeenInboxIntercept();
  const setSeenIntercept = useSetSeenInboxInterceptSetting();
  useEffect(() => {
    if (!hasSeenIntercept) {
      setIsOpen(true);
      setSeenIntercept(true);
      trackHelpDeskInterceptEvent('viewed interception', 'alert');
    }
  }, [hasSeenIntercept, setSeenIntercept]);
  const onClickGoToHelpDesk = () => {
    trackHelpDeskInterceptEvent('clicked go to help desk', 'alert');
  };
  const onDismissIntercept = () => {
    setIsOpen(false);
    setSeenIntercept(true);
    trackHelpDeskInterceptEvent('dismissed interception', 'alert');
  };
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(HelpDeskInterceptAlert, {
    onClickGoToHelpDesk: onClickGoToHelpDesk,
    onDismiss: onDismissIntercept
  });
};
MaybeHelpDeskInboxIntercept.displayName = 'MaybeHelpDeskInboxIntercept';